<template>
  <div class="equipmentPie" id="equipmentPie" ref="equipmentPie"></div>
</template>

<script>
export default {
  name: "equipmentPie",
  mounted() {
    this.equipmentPie();
  },
  methods: {
    equipmentPie() {
      let myEchart = this.$echarts.init(
        document.getElementById("equipmentPie")
      );

      let color = [
        "#ffa83c",
        "#55a90d",
        "#E271DE",
        "#F8456B",
        "#00FFFF",
        "#4AEAB0",
      ];
      let echartData = [
        {
          name: "在线",
          value: "54",
        },
        {
          name: "离线",
          value: "21",
        },
      ];

      let option = {
        color: color,
        grid: {
        top:'10%',
        left:'1%',
        bottom:'2%',
        right:'0%',
        containLabel: true,
    },
        series: [
          {
            type: "pie",
            radius: ["45%", "60%"],
            center: ["50%", "50%"],
            data: echartData,
            hoverAnimation: false,
            labelLine: {
              normal: {
                length: 20,
                length2: 35,
              },
            },
            label: {
                normal: {

                formatter: params => {
                    return (
                        '{name|' + params.name + ':}{value|' + params.value + '%}'
                    );
                },
                 padding: [0 , -40, 25, -40],
                rich: {
                    name: {
                        fontSize: 10,
                        padding: [0, 2, 0, 0],
                        color: '#ababab'
                    },
                    value: {
                        fontSize: 10,
                        color:'#fff'
                       
                    }
                }
            }
            },
          },
        ],
      };

      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.equipmentPie {
  width: 100%;
  height: 100%;
}
</style>
